import { HttpResponse } from '@angular/common/http';

export function extractFileDetails(res: HttpResponse<Blob>): { filename: string; blob: Blob } {
  const contentDisposition = res.headers.get('content-disposition');
  const filename = contentDisposition || 'downloaded_file';
  const blob = res.body as Blob;

  return { filename, blob };
}
